import { useState } from "react";
import { animeList, categories } from "@/mocks/anime";
import SectionHeading from "./SectionHeading";

export default function WeeklyPick() {
  const [active, setActive] = useState('全部');
  const picks = active === '全部' ? animeList.slice(0, 3) : animeList.filter((i) => i.category === active).slice(0, 3);

  return (
    <section id="pick" className="relative overflow-hidden bg-background-950 py-14 md:py-20">
      <div className="absolute inset-0 opacity-15">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20abstract%20warm%20gradient%20background%20with%20soft%20orange%20glowing%20orbs%20and%20teal%20accents%2C%20grainy%20texture%2C%20minimal%20artistic%20cinematic%20background%2C%20evokes%20cozy%20night%20movie%20marathon&width=1600&height=900&seq=pick-bg&orientation=landscape"
          alt="本周补番清单背景装饰"
          title="小虎看番 - 本周补番清单"
          className="h-full w-full object-cover"
        />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold uppercase tracking-wider text-background-50">
          <i className="ri-flashlight-fill" />
          本周清单
        </span>
        <div className="mt-3 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="font-heading text-2xl text-background-50 md:text-4xl">本周小虎精选三连推</h2>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-background-300 md:text-base">
              每周更新一期片单，按你想补的方向切换，给你挑出最对胃口的三部，别错过小虎本周的诚意之选。
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {categories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setActive(c)}
              className={`inline-flex items-center gap-1 rounded-full px-3.5 py-1.5 text-sm whitespace-nowrap transition-colors ${
                active === c
                  ? 'bg-primary-500 font-medium text-background-50'
                  : 'bg-background-50/10 text-background-200 hover:bg-background-50/20'
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {picks.map((item) => (
            <article key={item.id} className="group flex flex-col gap-4 rounded-lg border border-background-800 bg-background-900/60 p-3 backdrop-blur-sm sm:flex-row sm:p-4">
              <div className="relative h-44 w-full shrink-0 overflow-hidden rounded-md bg-background-800 sm:h-40 sm:w-24 md:w-28">
                <img
                  src={item.image}
                  alt={`本周推荐：${item.title}`}
                  title={`${item.title} - 小虎看番本周精选`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col">
                <div className="flex items-center justify-between gap-2">
                  <h4 className="font-heading text-lg text-background-50 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h4>
                  <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-background-50/10 px-2 py-0.5 text-xs font-bold text-background-100">
                    <i className="ri-star-fill text-amber-400" />
                    {item.score.toFixed(1)}
                  </span>
                </div>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span key={tag} className="rounded-full bg-secondary-500/20 px-2 py-0.5 text-xs text-secondary-300">
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="mt-3 line-clamp-2 text-xs leading-5 text-background-300">{item.synopsis}</p>
                <div className="mt-3 flex items-center gap-3 text-xs text-background-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-film-line" />
                    {item.episodes} 集
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-price-tag-3-line" />
                    {item.category}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}